import { affiliateApiFetch } from '@/lib/affiliateClientApi';

type TenantMembership = {
  affiliateId: string;
  onboardingStatus: string | null;
};

/**
 * Where to land after affiliate login / session restore.
 * Checks tenants + onboarding before entering the main panel.
 */
export async function resolveAffiliateEntryPath(locale: string): Promise<string> {
  const base = `/${locale}/affiliate-panel`;
  const tenantsRes = await affiliateApiFetch('/api/affiliate/tenants');
  if (tenantsRes.status === 401) {
    return `${base}/login`;
  }
  if (!tenantsRes.ok) {
    return base;
  }

  const data = (await tenantsRes.json()) as {
    affiliates?: TenantMembership[];
    selectedAffiliateId?: string | null;
  };
  const affiliates = Array.isArray(data.affiliates) ? data.affiliates : [];
  if (affiliates.length === 0) {
    return base;
  }

  const selectedId =
    typeof data.selectedAffiliateId === 'string'
      ? data.selectedAffiliateId
      : affiliates[0]?.affiliateId ?? null;

  if (selectedId) {
    await affiliateApiFetch('/api/affiliate/select', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ affiliateId: selectedId }),
    });
  }

  const selected =
    affiliates.find((a) => a.affiliateId === selectedId) ?? affiliates[0] ?? null;
  if (!selected || selected.onboardingStatus !== 'COMPLETED') {
    return `${base}/onboarding`;
  }

  return base;
}
